import React from 'react';
import styled from 'styled-components';
import { DateSelect } from 'components/FormFields';
import { Icon, PlainButton } from 'components/v3';
import { phone } from '../palette';
import { inputPropTypes } from './TextInputs';

// Date (FormFields DateSelect; answers are "YYYY-MM-DD", DateSelect speaks
// "MM-DD-YYYY") and the file field, which is switched off in the preview.

export const isoToSelect = (iso) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(
    typeof iso === 'string' ? iso : ''
  );
  return m ? `${m[2]}-${m[3]}-${m[1]}` : '';
};

export const selectToIso = (mdy) => {
  const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(
    typeof mdy === 'string' ? mdy : ''
  );
  return m ? `${m[3]}-${m[1]}-${m[2]}` : '';
};

// Wide enough for a date of birth and for upcoming race dates.
const YEARS_BACK = 100;
const YEARS_AHEAD = 10;

export const DateInput = ({
  value,
  onChange,
  labelId,
  describedBy,
  invalid,
}) => {
  const year = new Date().getFullYear();
  return (
    <div role="group" aria-labelledby={labelId} aria-describedby={describedBy}>
      <DateSelect
        value={isoToSelect(value)}
        onChange={(mdy) => onChange(selectToIso(mdy))}
        error={!!invalid}
        startYear={year - YEARS_BACK}
        endYear={year + YEARS_AHEAD}
      />
    </div>
  );
};
DateInput.propTypes = inputPropTypes;

const FileBox = styled(PlainButton)`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 20px;
  border: 1px dashed ${(p) => phone(p.theme).dash};
  border-radius: 8px;
  background: ${(p) => phone(p.theme).surface};
  color: ${(p) => phone(p.theme).text2};
  font-size: 13px;
  text-align: center;

  &:disabled {
    cursor: not-allowed;
  }

  svg {
    color: ${(p) => phone(p.theme).accent};
  }
`;

// Uploads need a real submission, so the preview shows the control
// disabled and never asks for the file.
export const FileInput = ({ inputId, describedBy }) => (
  <FileBox id={inputId} aria-describedby={describedBy} disabled>
    <Icon name="upload" size={24} />
    <span>Uploads are off in preview</span>
  </FileBox>
);
FileInput.propTypes = inputPropTypes;
